import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=7202ed30&scoped=true"
import script from "./ProductDetail.vue?vue&type=script&lang=ts"
export * from "./ProductDetail.vue?vue&type=script&lang=ts"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&id=7202ed30&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7202ed30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7202ed30')) {
      api.createRecord('7202ed30', component.options)
    } else {
      api.reload('7202ed30', component.options)
    }
    module.hot.accept("./ProductDetail.vue?vue&type=template&id=7202ed30&scoped=true", function () {
      api.rerender('7202ed30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/components/ProductDetail.vue"
export default component.exports